import mixpanel from 'mixpanel-browser';

// Initialize Mixpanel
const isProduction = () => {
  if (typeof window === 'undefined') return false;
  const hostname = window.location.hostname;
  return hostname === 'atly.com' || 
         hostname.includes('.atly.com') || 
         hostname.includes('production') || 
         hostname === 'www.atly.com' ||
         hostname === 'atly4seo.vercel.app' ||
         hostname.includes('vercel.app') ||
         !hostname.includes('localhost');
};

// Get token from environment or use default
const token = process.env.NEXT_PUBLIC_MIXPANEL_TOKEN || '72123733c2cb16af4962b13a8c0c1243';

// Initialize with configuration
mixpanel.init(token, {
  track_pageview: false,
  debug: !isProduction(),
  persistence: 'localStorage',
  cross_subdomain_cookie: true,
  cross_site_cookie: true,
  record_sessions_percent: 2,
  record_idle_timeout_ms: 1800000,
  record_max_ms: 3600000,
  record_heatmap_data: true
});

// Export the initialized mixpanel instance
export default mixpanel;
